/**
 * Utility for equality check.
 */
export default class EqualsUtility {
    /**
     * Performs a deep equals check on the two values.
     *
     * @param value1 The first value.
     * @param value2 The second value.
     */
    static deepEquals(value1, value2) {
        // Check if same values or object references before other more expensive checks.
        if (value1 === value2) {
            return true;
        }
        if (this.isObject(value1) && this.isObject(value2)) {
            return this.deepEqualObjects(value1, value2);
        }
        return value1 === value2;
    }
    /**
     * Performs a deep equals check on the two objects.
     *
     * @param object1 ...
     * @param object2 ...
     */
    static deepEqualObjects(object1, object2) {
        if (Object.keys(object1).length !== Object.keys(object2).length) {
            return false;
        }
        // Compare objects with same number of keys
        for (const key in object1) {
            if (!(key in object2)) {
                return false;
            }
            // Recurse through the keys.
            if (!this.deepEquals(object1[key], object2[key])) {
                return false;
            }
        }
        return true;
    }
    /**
     * Checks whether the value is of type object.
     *
     * @param value ...
     */
    static isObject(value) {
        return !!value && value === Object(value);
    }
}
//# sourceMappingURL=EqualsUtility.js.map